import React, { useState } from "react";
import {
  Box,
  Card,
  Checkbox,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
  Button,
  Typography,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useAuth } from 'providers/AuthContextProvider'; 
import API from 'api/API';
import { isValidCurp } from "utils/isValidCurp";
import isValidPassword from "utils/isValidPassword";
 
export default function DeleteAccountForm({ setSnackbarState }) {
    const {login, logout} = useAuth();
    const [reason, setReason] = useState(null);
    const [curp, setCurp] = useState(null);
    const [password, setPassword] = useState(null);
    const [details, setDetails] = useState("");
    const [ack, setAck] = useState(false);
    const [loading, setLoading] = useState(false);

    const postLogin = async() => {


        if(!isValidCurp(curp)){
            setSnackbarState({open:true, message:"Proporciona un CURP valida", status:"warning"})
            return
        }

         if(!isValidPassword(curp)){
            setSnackbarState({open:true, message:"Contraseña invalida", status:"warning"})
            return
        }
        
        const requestBody = {
            curp: curp.toLowerCase(),
            password: password
        }
        setLoading(true)
        const response = await API.postLogin(requestBody)
        setLoading(false)
        if(response.status == 200){
            deleteUser(response.data.user)
        }else{
            setSnackbarState({open:true, message: response.message, status: "error"})
        }
    };

    const deleteUser = async(user) => {
        
        const queryParams = {
            id: user.id
        }
        setLoading(true)
        const response = await API.deleteUser(queryParams)
        setLoading(false)
        if(response.status == 200){
            logout()
        }else{
            setSnackbarState({open:true, message: response.message, status: "error"})
        }
    };

    const deleteReasons = [
        "No utilizo la aplicación",
        "Problemas con el servicio",
        "Preocupación por privacidad",
        "Otro"
    ];

    return (
        <Box
            sx={{
                height: "100%",
                overflowY: "auto",
                p: 2,
            }}
        >
        <Grid container direction="column" spacing={2}>
            {/* Banner de advertencia */}
            <Grid item>
                <Card
                    elevation={0}
                    sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#ffe5d3ff",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    }}
                >
                    <WarningAmberIcon sx={{ color: "#FF8C00", fontSize: 28 }} />

                    <Box>
                    <Typography variant="h6" fontWeight="bold">
                        Eliminar cuenta
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Esta acción es permanente. Asegúrate de que deseas continuar.
                    </Typography>
                    </Box>
                </Card>
            </Grid>

            {/* Motivo / Dropdown */}
            <Grid item>
                <FormControl fullWidth>
                    <InputLabel>Motivo (opcional)</InputLabel>
                    <Select
                    label="Motivo (opcional)"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    >
                    {deleteReasons.map((r, i) => (
                        <MenuItem key={i} value={r}>
                        {r}
                        </MenuItem>
                    ))}
                    </Select>
                    <FormHelperText>¿Por qué deseas eliminar tu cuenta?</FormHelperText>
                </FormControl>
            </Grid>

            {/* CURP */}
            <Grid item>

                <TextField
                    required
                    fullWidth
                    id="curp"
                    value={curp}
                    onChange={(e) => setCurp(e.target.value)}
                    label="CURP"
                    name="curp"
                    autoComplete="curp"
                    autoFocus
                    helperText="Necesitamos verificar tu CURP"
                />
            </Grid>

            {/* Contraseña */}
            <Grid item>
                <TextField
                    label="Contraseña"
                    required
                    type="password"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    helperText="Necesitamos verificar tu contraseña"
                />
            </Grid>

            {/* Descripción adicional */}
            <Grid item>
                <TextField
                    label="Notas adicionales (opcional)"
                    fullWidth
                    multiline
                    rows={4}
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                    inputProps={{ maxLength: 300 }}
                    helperText={`${details.length}/300`}
                />
            </Grid>

            {/* Confirmación */}
            <Grid item>
                <FormControlLabel
                    control={
                    <Checkbox checked={ack} onChange={(e) => setAck(e.target.checked)} />
                    }
                    label="Confirmo que deseo eliminar mi cuenta y entiendo que es irreversible."
                />
            </Grid>

            {/* Botón */}
            <Grid item>
                <Button
                    onClick={postLogin}
                    variant="contained"
                    color="error"
                    fullWidth
                    sx={{ mt: 3, mb: 2, position: 'relative' }}
                    disabled={loading || !ack}
                >
                    {loading ? (
                    <CircularProgress size={24} color="inherit" />
                    ) : (
                    'Aceptar'
                    )}
                </Button>
            </Grid>
        </Grid>
        </Box>
    );
}
